import type { POLL_AUTH, Question } from 'schema/poll';

export const isAuthQuestion = (question: Question): question is POLL_AUTH => {
  return question.data.type === 'POLL_AUTH';
};
